import * as React from "react";
import { Radio, RadioGroup } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";

export const FluentRadio = ({
  label,
  disabled,
  layout = "horizontal",
  value,
  options,
  name,
  onChange,
  type,
  validationMessage,
  size = "medium"
}) => (
  <FluentField
    label={label}
    validationMessage={validationMessage}
    size={size}
  >
    <RadioGroup
      value={value}
      disabled={disabled}
      layout={layout}
      name={name}
      onChange={onChange}
    >
      {type === "dynamicField"
        ? options.map((option) => (
            <Radio key={option} value={option} label={option} />
          ))
        : options.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              label={option.label}
            />
          ))}
    </RadioGroup>
  </FluentField>
);

FluentRadio.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  layout: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  validationMessage: PropTypes.string,
  size: PropTypes.string,
};
